import Invoice6Container from "../../../../components/applications/eCommerce/invoices/invoice6";

const Invoice6 = () => {
  return <Invoice6Container />;
};

export default Invoice6;
